import React, { useState } from 'react';
import axios from 'axios'; // Import Axios
import styles from '../Components/ContactUs.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    title: '',
    email: '',
    message: ''
  });

  const [error, setError] = useState('');
  const [result, setResult] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const validateEmail = async (email) => {
    try {
      const response = await axios.get(`https://api.emailverifier.com/v1/verify?email=${email}&apiKey=YOUR_API_KEY`);
      return response.data.status === 'valid';
    } catch (error) {
      console.error('Error verifying email:', error);
      return false;
    }
  };

  const validateForm = async () => {
    if (!formData.title.trim()) {
      setError('* Title field should not be empty.');
      return false;
    }

    if (!formData.email.trim()) {
      setError('* Email field should not be empty.');
      return false;
    }

    const emailValid = await validateEmail(formData.email);
    if (!emailValid) {
      setError('* Enter a valid and existing email address.');
      return false;
    }

    if (!formData.message.trim()) {
      setError('* Message field should not be empty.');
      return false;
    }

    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setResult('');

    if (await validateForm()) {
      setResult('Sending....');

      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('message', formData.message);
      formDataToSend.append('access_key', '9fe4c564-62ee-4cfa-8ab3-9e351e90da9d');

      try {
        const response = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          body: formDataToSend,
        });

        const data = await response.json();

        if (data.success) {
          setResult('Form Submitted Successfully');
          setFormData({ title: '', email: '', message: '' });
          setError('');
        } else {
          setError('Error: ' + data.message);
          setResult('');
        }
      } catch (error) {
        setError('* Failed to send the form. Please try again later.');
        setResult('');
      }
    }
  };

  return (
    <div className={styles.contactUsPage}>
      <div className={styles.overlay}></div>
      <div className={styles.container}>
        <div className={styles.textCenter}>
          <h1>Contact Us</h1>
          <div>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
            <div>et dolore magna aliqua. Ut enim ad minim veniam.</div>
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.col1}>
            <div className={styles.addressLine}>
              <FontAwesomeIcon icon={faLocationDot} className={styles.icon} />
              <div className={styles.contactInfo}>
                <div className={styles.contactInfoTitle}>Address</div>
                <div>Shital Paints Drive in Road,</div>
                <div>Ahmedabad.</div>
              </div>
            </div>
            <div className={styles.addressLine}>
              <FontAwesomeIcon icon={faPhone} className={styles.icon} />
              <div className={styles.contactInfo}>
                <div className={styles.contactInfoTitle}>Phone</div>
                <div>12523-4566-8954-8956.</div>
              </div>
            </div>
            <div className={styles.addressLine}>
              <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
              <div className={styles.contactInfo}>
                <div className={styles.contactInfoTitle}>Email</div>
                <div>contactemail@gmail.com</div>
              </div>
            </div>
            <div className={styles.mapContainer}>
              <iframe
                title="Google Maps Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14684.32045424508!2d72.6165952!3d23.057524300000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e84bb447da0ab%3A0x597ce1205275d86d!2sShree%20Karoli%20Paints!5e0!3m2!1sen!2sin!4v1724874097084!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </div>
          <div className={styles.col2}>
            
              <div className={styles.formContainer}>
                <h2>Send Message</h2>
                {error && <div className={styles.error}>{error}</div>}
                <div className={styles.formRow}>
                  <label htmlFor="title">Title</label>
                  <input
                    id="title"
                    type="text"
                    className={styles.formField}
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className={styles.formRow}>
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    className={styles.formField}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className={styles.formRow}>
                  <label htmlFor="message">Type your message...</label>
                  <textarea
                    id="message"
                    className={styles.formField}
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className={styles.sendBtn}>Send</button>
                {result && <span className={styles.resultMessage}>{result}</span>}
              </div>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
